import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Collapse, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container } from "reactstrap";

// Sidebar for the payment-lead full view (/payment layout). Mirrors
// CustomerSidebar but only renders tabs whose route layout is "/payment".
const PaymentSidebar = (props) => {
  const url = window.location.href;
  const pathParts = new URL(url).pathname.split("/");
  const cid = pathParts[3];
  const lid = pathParts[4];

  const [collapseOpen, setCollapseOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("section-customer");
  const navigate = useNavigate();

  const toggleCollapse = () => setCollapseOpen((data) => !data);
  const closeCollapse = () => setCollapseOpen(false);

  // Map a nav-entry name to its section id in the payment full-view (PaymentLead).
  const getSectionId = (name) => {
    const n = name.toLowerCase().trim();
    if (n === "json") return "section-json";
    if (n.startsWith("leads")) return "section-leads";
    // Installment lives inside the Lead card's Installment tab.
    if (n.startsWith("installment")) return "section-leads";
    if (n === "credit history") return "section-credit-history";
    return `section-${n.replace(/\s+/g, "-")}`;
  };

  // Single-scroll payment view: scroll to the chosen section (fall back to opening the full-view).
  const handleNavigate = (e, prop) => {
    e.preventDefault();
    closeCollapse();
    const targetId = getSectionId(prop.name);
    setActiveSection(targetId);
    // Installment / Leads open the matching tab inside the Lead card.
    const n = prop.name.toLowerCase().trim();
    if (n.startsWith("installment")) {
      window.dispatchEvent(new CustomEvent("open-lead-tab", { detail: "installment" }));
    } else if (n.startsWith("leads")) {
      window.dispatchEvent(new CustomEvent("open-lead-tab", { detail: "lead" }));
    }
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/payment/full-view/${cid}/${lid}#${targetId}`);
    }
  };

  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/payment" && prop.display !== false && prop.name) {
        const isActive = activeSection === getSectionId(prop.name);

        return (
          <NavItem key={key}>
            <NavLink
              href={`#${getSectionId(prop.name)}`}
              onClick={(e) => handleNavigate(e, prop)}
              className={isActive ? "active font-weight-bold" : ""}
              style={{
                cursor: "pointer",
                borderLeft: isActive ? "4px solid #5e72e4" : "4px solid transparent",
                color: isActive ? "#5e72e4" : "#525f7f",
                backgroundColor: isActive ? "rgba(94, 114, 228, 0.08)" : "transparent",
                paddingLeft: "20px",
                transition: "all 0.3s ease",
              }}
            >
              <i className={`${prop.icon} ${isActive ? "text-primary" : ""}`} />
              {prop.name}
            </NavLink>
          </NavItem>
        );
      }
      return null;
    });
  };

  const { routes, logo } = props;
  return (
    <Navbar className="navbar-vertical fixed-left navbar-light bg-white" expand="md" id="sidenav-main">
      <Container fluid>
        <button className="navbar-toggler" type="button" onClick={toggleCollapse}>
          <span className="navbar-toggler-icon" />
        </button>
        {logo && (
          <NavbarBrand className="pt-0" to={logo.innerLink} tag={Link}>
            <img alt={logo.imgAlt} className="navbar-brand-img" src={logo.imgSrc} />
          </NavbarBrand>
        )}
        <Collapse navbar isOpen={collapseOpen}>
          <Nav navbar>{createLinks(routes)}</Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default PaymentSidebar;
